import { useTRPC } from '@/lib/trpc';
import { useQuery } from '@tanstack/react-query';

export function useGlobalAdmin() {
  const trpc = useTRPC();
  const { data: me } = useQuery(trpc.user.me.queryOptions());

  return { isGlobalAdmin: me?.isGlobalAdmin === true };
}
